export default "__VITE_ASSET__I6W61AEB__"